module.exports = __webpack_public_path__ + "img/whatsapp.8b357b47.png";